import { IController } from 'angular';
import * as _ from 'lodash';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';

export class LeadStepCtrl implements IController {
  static $inject = ['$scope', 'ImUser'];

  // Bindings
  private resolvedSchoolUsers;
  private supportContacts;

  constructor(private $scope, private imUser: ImUser) {}

  $onInit() {
    // list
    this.supportContacts = this.createContactList(this.resolvedSchoolUsers);
  }

  // Functions

  // create contact list dropdown
  createContactList = function(resolvedSchoolUsers) {
    let contactList = [];
    _.forEach(resolvedSchoolUsers, (user: any) => {
      let tempObj = {
        userId: user._id,
        email: this.imUser.getEffectiveEmail(user),
        name: user.name.firstName + ' ' + user.name.lastName,
      };
      contactList.push(tempObj);
    });
    return contactList;
  };

  // validate field is valid
  validateLeadStep = support => {
    return support.activityLead.userId ? false : true;
  };

  // takes activityLead and popluates mini-schema based on email selected
  populateMiniSchema = function(activityLeadUserId) {
    const userData: any = _.find(this.resolvedSchoolUsers, { _id: activityLeadUserId });
    const userMiniSchema = {
      userId: userData._id,
      gafeEmail: userData.gafeEmail,
      doeEmail: userData.doeEmail,
      firstName: userData.name.firstName,
      lastName: userData.name.lastName,
    };
    this.currentSupport.activityLead = userMiniSchema;
    this.currentSupport.effectiveEmail = this.imUser.getEffectiveEmail(userMiniSchema);
  };
}
angular.module('nv.SupportsModule').controller('leadStepCtrl', LeadStepCtrl);
